<template>
  <v-row class="justify-center">
    <v-col
      v-for="product in products"
      :key="product._id"
      cols="12"
      sm="4">
      <v-card
        class="pa-4 text-center"
        hover
        :disabled="disabled"
        v-bind="activeProps(product.oaChatMonth)"
        @click="updateOaChatMonth(product.oaChatMonth)">
        <div class="text-capitalize font-weight-bold _fs-36">
          <span :class="{ 'primary--text': !isOaChatMonthSelect(product.oaChatMonth) }">
            {{ product.oaChatMonth }} เดือน
          </span>
        </div>

        <img
          class="my-4 package-icon"
          :class="{ 'is-active': isOaChatMonthSelect(product.oaChatMonth) }"
          :src="`/svg/package-${product.oaChatMonth}m.svg`"
        />

        <div
          class="font-weight-bold _fs-36"
          :class="{ 'primary--text': !isOaChatMonthSelect(product.oaChatMonth) }">
          {{ product.unitPrice | numberComma }} บาท
        </div>

        <div
          class="_fs-14"
          :class="{ 'error--text': !isOaChatMonthSelect(product.oaChatMonth) }">
          * ราคาดังกล่าวไม่รวมภาษีมูลค่าเพิ่ม 7%
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'OrderOaChatMonthProduct',
  props: {
    products: {
      type: Array,
      default: () => []
    },
    oaChatMonth: {
      type: Number,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    updateOaChatMonth (value) {
      this.$emit('update:oa-chat-month', value)
    },
    isOaChatMonthSelect (value) {
      return this.oaChatMonth === value
    },
    activeProps (value) {
      if (this.isOaChatMonthSelect(value)) {
        return {
          dark: true,
          color: 'primary',
          style: { opacity: '0.7' }
        }
      }

      return {}
    }
  }
}
</script>

<style scoped>
.package-icon {
  filter: none;
}

.package-icon.is-active {
  filter: brightness(0) invert(1);
}
</style>
